<div class="slider-container">
  <div class="slider">
    <input class="radio" type="radio" name="event" id="cardEvent5" checked (click)="selectedEvent(5)"/>
    <label class="content" for="cardEvent5"></label>

    <input class="radio" type="radio" name="event" id="cardEvent4" (click)="selectedEvent(4)"/>
    <label class="content" for="cardEvent4"></label>

    <input class="radio" type="radio" name="event" id="cardEvent3" (click)="selectedEvent(3)"/>
    <label class="content" for="cardEvent3"></label>

    <input class="radio" type="radio" name="event" id="cardEvent2" (click)="selectedEvent(2)"/>
    <label class="content" for="cardEvent2"></label>

    <input class="radio" type="radio" name="event" id="cardEvent1" (click)="selectedEvent(1)"/>
    <label class="content" for="cardEvent1"></label>
  </div>
  <div class="buttons">
    <div class="button" (click)="changeSlider(1)">
      <mat-icon class="custom-height">arrow_left</mat-icon>
    </div>
    <div class="button" (click)="changeSlider(-1)">
      <mat-icon class="custom-height">arrow_right</mat-icon>
    </div>
  </div>
</div>
